import { IGetListYearGroupService } from "../../../../../abstractions/services/actions/IGetListYearGroupService";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import {
  fx_createMonitoreoBrocaGetSemanaGroupListByFincaIdService,
  MonitoreoBrocaSemanaGroup,
} from "../../../../../modulos/monitoreo/broca/services/MonitoreoBrocaGetSemanaGroupListByFincaIdService";
import { BaseYearGroupSelectorRender } from "../../../../base/selector/BaseYearGroupSelectorRender";

/** Selector compacto año/semana de Monitoreo Broca (un panel de la vista
 *  dividida). Notifica el grupo de semana elegido. */
export class MonitoreoBrocaSemanaSelectorRender extends BaseYearGroupSelectorRender<MonitoreoBrocaSemanaGroup> {
  /** @param _onSemana Notifica el grupo de semana seleccionado. */
  constructor(
    private readonly _onSemana: (semana: MonitoreoBrocaSemanaGroup) => void,
  ) {
    super();
  }

  /** Monitoreos de la finca activa agrupados por año → semana ISO. */
  protected getYearGroupListService(): IGetListYearGroupService<MonitoreoBrocaSemanaGroup> {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return fx_createMonitoreoBrocaGetSemanaGroupListByFincaIdService(finca.id);
  }

  /** "Semana N". */
  protected getItemLabel(item: MonitoreoBrocaSemanaGroup): string {
    return `Semana: ${item.semana}`;
  }

  protected onSelectionChange(item: MonitoreoBrocaSemanaGroup): void {
    this._onSemana(item);
  }
}
